// src/Components/About.js
import React, { Component } from "react";
import Fade from "react-reveal";

class About extends Component {
  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const pp = "images/" + this.props.data.image;
    const bio = this.props.data.bio;
    const city = this.props.data.address.city;
    const state = this.props.data.address.state;
    const phone = this.props.data.phone;
    const email = this.props.data.email;

    return (
      <section id="about">
        {/* whole section fade in */}
        <Fade bottom duration={900} distance="24px">
          <div className="row about-row">
            {/* profile picture column */}
            <div className="three columns">
              <Fade left duration={900} distance="24px">
                <img className="profile-pic" src={pp} alt={name} />
              </Fade>
            </div>

            {/* text card */}
            <div className="nine columns main-col about-card">
              <Fade right duration={900} distance="24px">
                <h2>About Me</h2>
                <p>{bio}</p>

                <div className="row">
                  <div className="columns contact-details">
                    <h2>Contact Details</h2>
                    <p className="address">
                      <span>{name}</span>
                      <span>
                        {city}, {state}
                      </span>
                      <span>{phone}</span>
                      <span>{email}</span>
                    </p>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default About;
